// src/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthValidation } from "../hooks/useAuthValidation"; // Ajuste o caminho conforme necessário

const PrivateRoute = ({ children, requiredLevelId, requiredRoles }) => {
  const { user, loading } = useAuthValidation();

  // Enquanto estiver carregando a autenticação
  if (loading) {
    return <div className="loading">Carregando...</div>; // Você pode substituir pelo seu componente de loading
  }

  // Se não houver usuário autenticado, redireciona para a página inicial (ou de login)
  if (!user) {
    return <Navigate to="/" />;
  }

  // Verificar se o usuário atende aos requisitos de level_id
  if (requiredLevelId && user.level.id !== requiredLevelId) {
    return <Navigate to="/home" />; // Redireciona para uma página adequada
  }

  // Verificar se o usuário atende aos requisitos de roles
  if (requiredRoles && requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some((role) => user.level.roles[role]);
    if (!hasRequiredRole) {
      return <Navigate to="/home" />; // Redireciona para uma página adequada
    }
  }

  // Se todas as verificações passarem, renderiza os componentes filhos
  return children;
};

export default PrivateRoute;
